<h1 class="page-title">How we monitor</h1>
<p class="nsw-intro">Find out how Beachwatch and our partners collect and test water samples.</p>

<nav class="nsw-in-page-nav bw-in-page-nav" aria-labelledby="in-page-nav">
    <div id="in-page-nav" class="nsw-in-page-nav__title">On this page</div>
    <ul>
        <li>
            <a [routerLink]="['./']" fragment="waterSampleCollectionSection">Water sample collection</a>
        </li>
        <li>
            <a [routerLink]="['./']" fragment="enterococciSection">Enterococci</a>
        </li>
        <li>
            <a [routerLink]="['./']" fragment="conductivitySection">Conductivity</a>
        </li>
        <li>
            <a [routerLink]="['./']" fragment="dissolvedOxygenSection">Dissolved oxygen</a>
        </li>
        <li>
            <a [routerLink]="['./']" fragment="waterTemperatureSection">Water temperature</a>
        </li>
        <li>
            <a [routerLink]="['./']" fragment="swimsiteObservations">Swim site observations</a>
        </li>        
    </ul>
</nav>

<section class="nsw-section" id="waterSampleCollectionSection">
    <div class="nsw-block">
        <h2>Water sample collection</h2>
        <p>  
            Beachwatch and our partners collect water samples when a swimming site is in use, 
            so the sampling frequency and monitoring period varies between swimming locations, but it occurs on a routine basis usually once a week. Sterile sampling techniques are used to avoid contamination.
            <br/><br/>
            It is difficult, expensive and impractical to measure the level of all contaminants in the water directly. Instead, our samples are tested for indicators to show if the water is polluted.
        </p>
    </div>               
</section>

<section class="nsw-section" id="enterococciSection">
    <div class="nsw-block">        
        <h2>Enterococci</h2> 
        <p>
            Water samples are tested in the laboratory for <i>enterococci</i> bacteria as an indicator of faecal contamination. 
            Swimming in water contaminated by faecal matter can expose you to disease-causing microorganisms which can make you unwell.
            <br/><br/>
            <i>Enterococci</i> results are usually not available until two to three days after the water sample is collected. This is due to the time required for bacterial colonies to grow and be counted in the laboratory.
        </p>
    </div>               
</section>

<section class="nsw-section" id="conductivitySection">
    <div class="nsw-block">        
        <h2>Conductivity</h2> 
        <p>
            Conductivity is the property of a substance that enables it to serve as a channel or medium for electricity. Salty water conducts electricity more readily than purer water. Therefore, electrical conductivity is routinely used to measure salinity. Significant changes in conductivity may indicate that a discharge or some other source of contamination has entered recreational waters. Each waterbody tends to have a relatively consistent range of electrical conductivity values that, once known, can be used as a baseline against which to compare regular measurements of conductivity. Marine waters have a higher conductivity than freshwater and therefore a reduction in conductivity can indicate freshwater influence from stormwater.
        </p>
    </div>               
</section>

<section class="nsw-section" id="dissolvedOxygenSection">
    <div class="nsw-block">
        <h2>Dissolved oxygen</h2> 
        <p>
            The amount of dissolved oxygen in a river, stream, or estuary can tell us a lot about its water quality. Low-oxygen conditions occur when water has become low in dissolved oxygen, typically less than 4 milligrams per litre. It occurs when bacterial numbers get too high, often in response to large amounts of organic material and nutrients being present in the water. Algae and cyanobacteria can rapidly grow out of control, or “bloom,” when water is warm, slow-moving, and full of nutrients.
        </p>        
    </div>               
</section>

<section class="nsw-section" id="waterTemperatureSection">
    <div class="nsw-block">
        <h2>Water temperature</h2> 
        <p>
            Water temperature can influence how other water quality indicators react, including the growth rate of microorganisms. For example, warmer temperatures can cause certain bacteria to grow and spread faster compared to cooler temperatures.
        </p>        
    </div>               
</section>

<section class="nsw-section" id="swimsiteObservations">
    <div class="nsw-block">
        <h2>Swim site observations</h2> 
        <p>
            Potential pollution indicators such as flowing stormwater drains, open lagoons, water users, discoloured water, odours, rubbish, leaf litter and water clarity are recorded when water samples are collected. 
            This information can help to identify potential pollution sources if elevated bacteria levels are detected.  
        </p> 
    </div>               
</section>
